export const apiConstants = {
  employees: '/users',
};
